<template>
    <div>
        <img  v-bind:src="require('@/assets/'+ left)" />
        <img  v-bind:src="require('@/assets/'+ right)" />
    </div>
</template>

<script>

//import ImgComparisonSlider from "img-comparison-slider"

export default {
  name: 'SideBySide',
  components:{
      //ImgComparisonSlider
  },
  props:{
      left:String,
      right:String
  }
}
</script>

<style>
    img{
        width:100%;
    }
</style>
